import { Box, Text } from '@ltvco/refresh-lib/theme';
import {
  SavedSearches,
  useSavedSearches,
  buildSearchQueryString,
  type UserSearch,
} from '@ltvco/refresh-lib/v2';
import { useNavigate } from 'react-router-dom';

/**
 * Authenticated saved-searches route. Ported from the Ember `saved-searches`
 * route + `searches/saved-searches` component.
 */
export function MarketplaceSavedSearches() {
  const navigate = useNavigate();
  const { searchesQuery, deleteSearchMutation, tokenReady } =
    useSavedSearches();

  const searches = searchesQuery.data?.searches ?? [];
  const isLoading = !tokenReady || searchesQuery.isLoading;

  const handleDelete = (userSearchId: string): void => {
    deleteSearchMutation.mutate(userSearchId);
  };

  const handleGoToSearch = (search: UserSearch): void => {
    const qs = buildSearchQueryString(
      search.searchCriteria as Record<string, unknown>,
    );
    navigate(`/marketplace${qs ? `?${qs}` : ''}`);
  };

  return (
    <Box maxWidth={1290} mx="auto" px={2} py={3}>
      <Text variant="h4" fontWeight={600} mb={3}>
        Saved Searches
      </Text>
      <SavedSearches
        searches={searches}
        isLoading={isLoading}
        onDelete={handleDelete}
        onGoToSearch={handleGoToSearch}
      />
    </Box>
  );
}
